export default __webpack_public_path__ + "static/media/déconnecter_nav_icon.3237f70b.svg";